require('./Fioc.scss');

const PropTypes = require('prop-types');
const { updateFiocRecordView } = require('utilities/taggingInfo/fiocTags');

// @ vendors
const React = require('react');

class Fioc extends React.Component {

    componentDidMount() {
        updateFiocRecordView();
    }

    buildRow(components) {
        const ret = components.map(element => {
            if (element.length) {
                return this.buildRowItems(element);
            }
            else {
                return this.buildRowItem(element, components.length);
            }
        });
        if (ret && ret[0] && ret[0].props.children) {
            return <div className="form-item row"> {ret} </div>;
        }
    }

    buildRowItem(component, rowLength) {
        const { buildComponent } = this.props;
        const componentSize = (component.size) ? 'col-xs-' + component.size : 'col-xs-' + Math.floor(12 / rowLength);
        const rowItem = buildComponent(component);
        const renderRow = rowItem && (
            <div className={componentSize}>
                {rowItem}
            </div>
        );

        return renderRow;
    }

    buildRowItems(components) {
        const { buildComponent } = this.props;
        const ret = components.map((element, index) => {
            return (<div key={index}>{buildComponent(element)}</div>);
        });

        return (<div className="col-xs-12">{ret}</div>);
    }

    buildTabForm(component) {
        return component.grid.map(element => this.buildRow(element));
    }

    render() {
        const { component } = this.props;
        return (
            <div className="fioc">
                {this.buildTabForm(component)}
            </div>
        );
    }

}

Fioc.propTypes = {
    buildComponent: PropTypes.func,
    component: PropTypes.object
};

module.exports = Fioc;